import Base from '../core/Base';

/**
 * Handles animated elements on the site.
 *
 * Usage example:
 * ==============
 * window.animations = new Animations('animation', 'animated');
 * window.anumations.paused = true;
 * window.anumations.paused = false;
 */
export default class Animations extends Base {

	/**
	 * Constructor method.
	 * @param  {string} selector Class selector for elements that will be animated
	 * @param  {string} animated Class name for animated elements
	 * @param  {bool}   repeat   Removes the animated class when the element is not in the viewport
	 */
	constructor(selector, animated, repeat) {
		super();
		this.selector = selector;
		this.animated = animated;
		this.repeat   = (repeat !== true) ? false : true;
		this.paused   = false;

		this.reindex();

		window.addEventListener('scroll',    e => this.update());
		window.addEventListener('touchmove', e => this.update());
		window.requestAnimationFrame(() => this.update());
	}

	/**
	 * Reindexes the animated elements.
	 * @return {undefined}
	 */
	reindex() {
		this.elements = document.querySelectorAll(`.${this.selector}:not(.${this.animated})`);
		for (let el of this.elements) {
			let offset         = el.getAttribute('data-offset');
			el.animationOffset = (offset) ? offset : 0;
		}
		this.update();
	}

	/**
	 * Handles animated elements in the viewport.
	 */
	update() {
		if (!this.paused) {
			for (let el of this.elements) {
				if (this.viewport(el, el.animationOffset)) {
					el.classList.add(this.animated);
				} else if (this.repeat) {
					el.classList.remove(this.animated);
				}
			}
		}
	}

}
